import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
// import SocketPlugin from './socket/socketPlugin';

Vue.config.productionTip = false

// Vue.use(SocketPlugin); // Use the plugin here

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
